import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Rodo from "./pages/Rodo";
import PolitykaPrywatnosci from "./pages/PolitykaPrywatnosci";
import Regulamin from "./pages/Regulamin";
import StandUpDlaFirm from "./pages/seo/StandUpDlaFirm";
import KomikNaEvent from "./pages/seo/KomikNaEvent";
import WystepNaIntegracje from "./pages/seo/WystepNaIntegracje";
import StandUpNaKonferencje from "./pages/seo/StandUpNaKonferencje";
import KomikNaImpreze from "./pages/seo/KomikNaImpreze";
import WystepNaGale from "./pages/seo/WystepNaGale";
import StandUpTeamBuilding from "./pages/seo/StandUpTeamBuilding";
import KomikNaWesele from "./pages/seo/KomikNaWesele";
import WystepKomediowyCena from "./pages/seo/WystepKomediowyCena";
import RoastFirmowy from "./pages/seo/RoastFirmowy";
import KomikWarszawa from "./pages/seo/KomikWarszawa";
import KomikKrakow from "./pages/seo/KomikKrakow";
import KomikWroclaw from "./pages/seo/KomikWroclaw";
import WystepSwiateczny from "./pages/seo/WystepSwiateczny";
import KomikNaJubileusz from "./pages/seo/KomikNaJubileusz";
import StandUpPoAngielsku from "./pages/seo/StandUpPoAngielsku";
import WystepNaSzkolenie from "./pages/seo/WystepNaSzkolenie";
import KomikNaUrodziny from "./pages/seo/KomikNaUrodziny";
import KomikPoznan from "./pages/seo/KomikPoznan";
import KomikGdansk from "./pages/seo/KomikGdansk";
import KomikKatowice from "./pages/seo/KomikKatowice";
import KomikLodz from "./pages/seo/KomikLodz";
import KomikLublin from "./pages/seo/KomikLublin";
import WystepOnline from "./pages/seo/WystepOnline";
import KomikNaKawalerski from "./pages/seo/KomikNaKawalerski";
import KomikNaEventMarketingowy from "./pages/seo/KomikNaEventMarketingowy";
import StandUpNaBankiet from "./pages/seo/StandUpNaBankiet";
import KomikNaOtwarcie from "./pages/seo/KomikNaOtwarcie";
import WystepNaSpotkaniuFirmowym from "./pages/seo/WystepNaSpotkaniuFirmowym";
import KomikNaSylwestra from "./pages/seo/KomikNaSylwestra";
import StandUpDzienKobiet from "./pages/seo/StandUpDzienKobiet";
import WystepKonferencjaIT from "./pages/seo/WystepKonferencjaIT";
import KomikNaPiknik from "./pages/seo/KomikNaPiknik";
import StandUpZakonczenieRoku from "./pages/seo/StandUpZakonczenieRoku";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/rodo" element={<Rodo />} />
          <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
          <Route path="/regulamin" element={<Regulamin />} />
          <Route path="/stand-up-dla-firm" element={<StandUpDlaFirm />} />
          <Route path="/komik-na-event" element={<KomikNaEvent />} />
          <Route path="/wystep-komediowy-na-integracje" element={<WystepNaIntegracje />} />
          <Route path="/stand-up-na-konferencje" element={<StandUpNaKonferencje />} />
          <Route path="/komik-na-impreze-firmowa" element={<KomikNaImpreze />} />
          <Route path="/wystep-komediowy-na-gale" element={<WystepNaGale />} />
          <Route path="/stand-up-team-building" element={<StandUpTeamBuilding />} />
          <Route path="/komik-na-wesele" element={<KomikNaWesele />} />
          <Route path="/wystep-komediowy-cennik" element={<WystepKomediowyCena />} />
          <Route path="/roast-firmowy" element={<RoastFirmowy />} />
          <Route path="/komik-warszawa" element={<KomikWarszawa />} />
          <Route path="/komik-krakow" element={<KomikKrakow />} />
          <Route path="/komik-wroclaw" element={<KomikWroclaw />} />
          <Route path="/wystep-komediowy-wigilia-firmowa" element={<WystepSwiateczny />} />
          <Route path="/komik-na-jubileusz-firmy" element={<KomikNaJubileusz />} />
          <Route path="/stand-up-po-angielsku" element={<StandUpPoAngielsku />} />
          <Route path="/wystep-komediowy-na-szkoleniu" element={<WystepNaSzkolenie />} />
          <Route path="/komik-na-urodziny" element={<KomikNaUrodziny />} />
          <Route path="/komik-poznan" element={<KomikPoznan />} />
          <Route path="/komik-gdansk" element={<KomikGdansk />} />
          <Route path="/komik-katowice" element={<KomikKatowice />} />
          <Route path="/komik-lodz" element={<KomikLodz />} />
          <Route path="/komik-lublin" element={<KomikLublin />} />
          <Route path="/wystep-komediowy-online" element={<WystepOnline />} />
          <Route path="/komik-na-wieczor-kawalerski" element={<KomikNaKawalerski />} />
          <Route path="/komik-na-event-marketingowy" element={<KomikNaEventMarketingowy />} />
          <Route path="/stand-up-na-bankiet" element={<StandUpNaBankiet />} />
          <Route path="/komik-na-otwarcie-firmy" element={<KomikNaOtwarcie />} />
          <Route path="/wystep-na-spotkaniu-firmowym" element={<WystepNaSpotkaniuFirmowym />} />
          <Route path="/komik-na-sylwestra" element={<KomikNaSylwestra />} />
          <Route path="/stand-up-dzien-kobiet" element={<StandUpDzienKobiet />} />
          <Route path="/wystep-komediowy-konferencja-it" element={<WystepKonferencjaIT />} />
          <Route path="/komik-na-piknik-firmowy" element={<KomikNaPiknik />} />
          <Route path="/stand-up-zakonczenie-roku" element={<StandUpZakonczenieRoku />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
